import { withBasePath } from '@/lib/config';

type HeroImageProps = {
  desktop: string;
  mobile: string;
  alt: string;
  className?: string;
  children?: React.ReactNode;
};

export default function HeroImage({ desktop, mobile, alt, className, children }: HeroImageProps) {
  return (
    <div className={`relative w-full ${className ?? ''}`}>
      <picture>
        <source
          media="(min-width: 1024px)"
          srcSet={withBasePath(desktop)}
          width={1920}
          height={650}
        />
        <img
          src={withBasePath(mobile)}
          alt={alt}
          width={800}
          height={800}
          className="block h-auto w-full"
          loading="eager"
          decoding="async"
        />
      </picture>
      {children && <div className="absolute inset-0">{children}</div>}
    </div>
  );
}
